import {observer} from "mobx-react";
import React from "react";

import {AddButton, SaveButton} from "../../atoms/buttons/buttons";
import {
    ActionsColumn,
    FieldsColumn,
    HeaderGrid,
    InputWidthWrapper,
    PageContainer,
} from "../../atoms/layouts/category-layout-containers";
import {ErrorText, FormField} from "../../molecules/inputs/form-field";
import {SubmitGroup} from "../../molecules/submit-group/submit-group";
import {CategoryRow} from "../../molecules/tables/category-row";
import {AdminBreadcrumb} from "../../organisms/admin-breadcrumb/admin-breadcrumb";
import {TableLayout} from "../../organisms/table-layout/table-layout";
import {AppLayout} from "../../templates/app-layout/app-layout";
import {CategoryGroupCreatePageStore} from "./category-group-create-page-store";

const columns = [
    {label: "カテゴリ名"},
    {label: "識別子（Slug）", width: 200},
    {label: "", width: 60, required: false},
];

export const CategoryGroupCreatePage: React.FC<{
    pageStore: CategoryGroupCreatePageStore;
}> = observer((props) => {
    const {
        tableRows,
        groupLabel,
        groupSlug,
        addCategory,
        removeCategory,
        setGroupLabel,
        setGroupSlug,
        setLabel,
        setSlug,
        createCategoryGroup,
        groupLabelError,
        groupSlugError,
        canCreate,
        duplicateError,
    } = props.pageStore;
    return (
        <AppLayout
            breadcrumb={
                <AdminBreadcrumb
                    factory={(builder) => builder.categoryGroups().custom("新規作成").build()}
                />
            }
            buttons={<></>}
        >
            <SubmitGroup
                onSubmit={async () => {
                    await createCategoryGroup();
                }}
                canSubmit={canCreate}
            >
                <PageContainer>
                    {
                        /* エラーメッセージの表示 */
                        duplicateError && <ErrorText>{duplicateError}</ErrorText>
                    }
                    {/* ヘッダー部分 */}
                    <HeaderGrid>
                        {/* 左カラム：ラベル付きフォームを縦に並べる */}
                        <FieldsColumn aria-label="カテゴリグループの入力フィールド">
                            <InputWidthWrapper>
                                <FormField
                                    label="カテゴリグループ名"
                                    required
                                    placeholder="グループ名を入力"
                                    value={groupLabel}
                                    onChange={(e) => setGroupLabel(e.currentTarget.value)}
                                    onBlur={(e) => setGroupLabel(e.currentTarget.value)}
                                    errorText={groupLabelError}
                                />
                            </InputWidthWrapper>

                            <InputWidthWrapper>
                                <FormField
                                    label="識別子（Slug）"
                                    required
                                    placeholder="コードを入力"
                                    value={groupSlug}
                                    onChange={(e) => setGroupSlug(e.currentTarget.value)}
                                    onBlur={(e) => setGroupSlug(e.currentTarget.value)}
                                    errorText={groupSlugError}
                                />
                            </InputWidthWrapper>
                        </FieldsColumn>

                        {/* 右カラム：アクションボタン（下端揃え） */}
                        <ActionsColumn>
                            <AddButton onClick={() => addCategory()}>カテゴリの追加</AddButton>
                            <SaveButton disabled={!canCreate}>保存</SaveButton>
                        </ActionsColumn>
                    </HeaderGrid>

                    {/* テーブル部分 */}
                    <TableLayout areaLabel="カテゴリ作成" columns={columns}>
                        {tableRows.map(({label, slug, categoryId, labelError, slugError}) => {
                            return (
                                <CategoryRow
                                    key={categoryId}
                                    id={categoryId}
                                    label={label}
                                    slug={slug}
                                    labelError={labelError}
                                    slugError={slugError}
                                    canRemove={tableRows.length > 1}
                                    onChangeLabel={setLabel}
                                    onChangeSlug={setSlug}
                                    onRemove={removeCategory}
                                />
                            );
                        })}
                    </TableLayout>
                </PageContainer>
            </SubmitGroup>
        </AppLayout>
    );
});
